import './Menu.scss';

import classNames from 'classnames';

import {useStaffUrl, useLocation} from 'hooks';

import Link, {LinkProps} from 'components/Common/Link';

type MenuButtonProps = LinkProps & {
  to: string;
};

const MenuButton = ({to: toProp, className, ...rest}: MenuButtonProps) => {
  const staffUrl = useStaffUrl();
  const to = staffUrl({to: `${toProp === '/' ? '' : `/${toProp}`}`});
  const {pathname} = useLocation();

  const isActive = () => {
    const isMatch = pathname.indexOf(to) === 0;

    if (isMatch) {
      if (toProp === '/') {
        return pathname === to;
      }

      return true;
    }

    return false;
  };

  return (
    <Link
      base={to}
      className={classNames('menu-button', className, {
        active: isActive(),
      })}
      {...rest}
    />
  );
};

export default MenuButton;
